module.exports = __webpack_public_path__ + "static/img/logo.3b934ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LogoIcons/logo.png
// module id = 0gEn
// module chunks = 1